@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import com.varabyte.kobweb.browser.api
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Suppress
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.dom.hasClass
import kotlinx.dom.removeClass
import org.jetbrains.compose.web.renderComposable
import org.w3c.dom.EventSource
import org.w3c.dom.EventSourceInit
import org.w3c.dom.MessageEvent
import org.w3c.dom.`get`
import co.maytes.standupbot.dashboard.pages.AnthropicKeyPage as _co_maytes_standupbot_dashboard_pages_AnthropicKeyPage
import co.maytes.standupbot.dashboard.pages.BootstrapPage as _co_maytes_standupbot_dashboard_pages_BootstrapPage
import co.maytes.standupbot.dashboard.pages.ChangelogPage as _co_maytes_standupbot_dashboard_pages_ChangelogPage
import co.maytes.standupbot.dashboard.pages.ContactPage as _co_maytes_standupbot_dashboard_pages_ContactPage
import co.maytes.standupbot.dashboard.pages.DocsPage as _co_maytes_standupbot_dashboard_pages_DocsPage
import co.maytes.standupbot.dashboard.pages.InviteAcceptPage as _co_maytes_standupbot_dashboard_pages_InviteAcceptPage
import co.maytes.standupbot.dashboard.pages.LandingPage as _co_maytes_standupbot_dashboard_pages_LandingPage
import co.maytes.standupbot.dashboard.pages.PricingPage as _co_maytes_standupbot_dashboard_pages_PricingPage
import co.maytes.standupbot.dashboard.pages.SignInPage as _co_maytes_standupbot_dashboard_pages_SignInPage
import co.maytes.standupbot.dashboard.pages.app.AppHomePage as _co_maytes_standupbot_dashboard_pages_app_AppHomePage
import co.maytes.standupbot.dashboard.pages.app.analytics.AnalyticsPage as _co_maytes_standupbot_dashboard_pages_app_analytics_AnalyticsPage
import co.maytes.standupbot.dashboard.pages.app.onboarding.OnboardingDonePage as _co_maytes_standupbot_dashboard_pages_app_onboarding_OnboardingDonePage
import co.maytes.standupbot.dashboard.pages.app.onboarding.OnboardingLinearPage as _co_maytes_standupbot_dashboard_pages_app_onboarding_OnboardingLinearPage
import co.maytes.standupbot.dashboard.pages.app.onboarding.OnboardingPreviewPage as _co_maytes_standupbot_dashboard_pages_app_onboarding_OnboardingPreviewPage
import co.maytes.standupbot.dashboard.pages.app.onboarding.OnboardingSetupPage as _co_maytes_standupbot_dashboard_pages_app_onboarding_OnboardingSetupPage
import co.maytes.standupbot.dashboard.pages.app.onboarding.OnboardingSlackPage as _co_maytes_standupbot_dashboard_pages_app_onboarding_OnboardingSlackPage
import co.maytes.standupbot.dashboard.pages.app.onboarding.OnboardingWelcomePage as _co_maytes_standupbot_dashboard_pages_app_onboarding_OnboardingWelcomePage
import co.maytes.standupbot.dashboard.pages.app.orgteams.OrgTeamsIndexPage as _co_maytes_standupbot_dashboard_pages_app_orgteams_OrgTeamsIndexPage
import co.maytes.standupbot.dashboard.pages.app.releases.ReleasesIndexPage as _co_maytes_standupbot_dashboard_pages_app_releases_ReleasesIndexPage
import co.maytes.standupbot.dashboard.pages.app.settings.SettingsHubPage as _co_maytes_standupbot_dashboard_pages_app_settings_SettingsHubPage
import co.maytes.standupbot.dashboard.pages.app.standupruns.StandupDetailPage as _co_maytes_standupbot_dashboard_pages_app_standupruns_StandupDetailPage
import co.maytes.standupbot.dashboard.pages.app.standupruns.StandupsIndexPage as _co_maytes_standupbot_dashboard_pages_app_standupruns_StandupsIndexPage
import co.maytes.standupbot.dashboard.pages.app.standups.NewTeamPage as _co_maytes_standupbot_dashboard_pages_app_standups_NewTeamPage
import co.maytes.standupbot.dashboard.pages.app.standups.TeamDetailPage as _co_maytes_standupbot_dashboard_pages_app_standups_TeamDetailPage
import co.maytes.standupbot.dashboard.pages.app.standups.TeamsIndexPage as _co_maytes_standupbot_dashboard_pages_app_standups_TeamsIndexPage
import co.maytes.standupbot.dashboard.pages.app.summary.SummaryPage as _co_maytes_standupbot_dashboard_pages_app_summary_SummaryPage
import co.maytes.standupbot.dashboard.pages.app.templates.TemplatesDynamicPage as _co_maytes_standupbot_dashboard_pages_app_templates_TemplatesDynamicPage
import co.maytes.standupbot.dashboard.pages.app.templates.TemplatesIndexPage as _co_maytes_standupbot_dashboard_pages_app_templates_TemplatesIndexPage
import co.maytes.standupbot.dashboard.pages.app.templates.TemplatesNewPage as _co_maytes_standupbot_dashboard_pages_app_templates_TemplatesNewPage
import co.maytes.standupbot.dashboard.pages.ds.DesignSystemPage as _co_maytes_standupbot_dashboard_pages_ds_DesignSystemPage
import co.maytes.standupbot.dashboard.pages.legal.PrivacyPage as _co_maytes_standupbot_dashboard_pages_legal_PrivacyPage
import co.maytes.standupbot.dashboard.pages.legal.TermsPage as _co_maytes_standupbot_dashboard_pages_legal_TermsPage
import co.maytes.standupbot.dashboard.pages.oauth.LinearCallbackPage as _co_maytes_standupbot_dashboard_pages_oauth_LinearCallbackPage
import co.maytes.standupbot.dashboard.pages.oauth.SlackCallbackPage as _co_maytes_standupbot_dashboard_pages_oauth_SlackCallbackPage

private fun forceReloadNow() {
    window.stop()
    window.location.reload()
}

private fun handleServerStatusEvents() {
    val status = document.getElementById("status")!!
    var lastVersion: Int? = null
    var shouldReload = false

    val warningIcon = status.children[0]!!
    val spinnerIcon = status.children[1]!!
    val statusText = status.children[2]!!

    status.addEventListener("transitionend", {
        if (status.hasClass("fade-out")) {
            status.removeClass("fade-out")
            if (shouldReload) {
                forceReloadNow()
            }
        }
    })

    val eventSource = EventSource("/api/kobweb-status", EventSourceInit(true))
    eventSource.addEventListener("version", { evt ->
        val version = (evt as MessageEvent).data.toString().toInt()
        if (lastVersion == null) {
            lastVersion = version
        }
        if (lastVersion != version) {
            lastVersion = version
            if (document.asDynamic().hidden) {
                // Reload immediately when the page is not visible as the animation will not run
                forceReloadNow()
            } else if (status.className.isNotEmpty()) {
                shouldReload = true
            } else {
                // Not sure if we can get here but if we can't rely on the status transition
                // to reload we should do it ourselves.
                forceReloadNow()
            }
        }
    })

    eventSource.addEventListener("status", { evt ->
        val values: dynamic = JSON.parse<Any>((evt as MessageEvent).data.toString())
        val text = values.text as String
        val isError = (values.isError as String).toBoolean()
        if (text.isNotBlank()) {
            warningIcon.className = if (isError) "visible" else "hidden"
            spinnerIcon.className = if (isError) "hidden" else "visible"
            statusText.innerHTML = "<i>$text</i>"
            status.className = "fade-in"
        } else {
            if (status.className == "fade-in") {
                status.className = "fade-out"
            }
        }
    })

    eventSource.onerror = { eventSource.close() }
}

public fun main() {
    handleServerStatusEvents()

    window.api.logOnError = true

    AppGlobals.initialize(mapOf("title" to "Standup Bot"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _co_maytes_standupbot_dashboard_pages_LandingPage()
        }
        ctx.router.register(
            "/app",
        ) { pageCtx -> 
            _co_maytes_standupbot_dashboard_pages_app_AppHomePage()
        }
        ctx.router.register(
            "/app/analytics",
        ) { pageCtx -> 
            _co_maytes_standupbot_dashboard_pages_app_analytics_AnalyticsPage()
        }
        ctx.router.register(
            "/app/onboarding/done",
        ) { pageCtx -> 
            _co_maytes_standupbot_dashboard_pages_app_onboarding_OnboardingDonePage()
        }
        ctx.router.register(
            "/app/onboarding/linear",
        ) { pageCtx -> 
            _co_maytes_standupbot_dashboard_pages_app_onboarding_OnboardingLinearPage()
        }
        ctx.router.register(
            "/app/onboarding/preview",
        ) { pageCtx -> 
            _co_maytes_standupbot_dashboard_pages_app_onboarding_OnboardingPreviewPage()
        }
        ctx.router.register(
            "/app/onboarding/setup",
        ) { pageCtx -> 
            _co_maytes_standupbot_dashboard_pages_app_onboarding_OnboardingSetupPage()
        }
        ctx.router.register(
            "/app/onboarding/slack",
        ) { pageCtx -> 
            _co_maytes_standupbot_dashboard_pages_app_onboarding_OnboardingSlackPage()
        }
        ctx.router.register(
            "/app/onboarding/welcome",
        ) { pageCtx -> 
            _co_maytes_standupbot_dashboard_pages_app_onboarding_OnboardingWelcomePage()
        }
        ctx.router.register(
            "/app/org-teams",
        ) { pageCtx -> 
            _co_maytes_standupbot_dashboard_pages_app_orgteams_OrgTeamsIndexPage()
        }
        ctx.router.register(
            "/app/releases",
        ) { pageCtx -> 
            _co_maytes_standupbot_dashboard_pages_app_releases_ReleasesIndexPage()
        }
        ctx.router.register(
            "/app/runs",
        ) { pageCtx -> 
            _co_maytes_standupbot_dashboard_pages_app_standupruns_StandupsIndexPage()
        }
        ctx.router.register(
            "/app/runs/{id}",
        ) { pageCtx -> 
            _co_maytes_standupbot_dashboard_pages_app_standupruns_StandupDetailPage()
        }
        ctx.router.register(
            "/app/settings/{tab?}",
        ) { pageCtx -> 
            _co_maytes_standupbot_dashboard_pages_app_settings_SettingsHubPage()
        }
        ctx.router.register(
            "/app/standups",
        ) { pageCtx -> 
            _co_maytes_standupbot_dashboard_pages_app_standups_TeamsIndexPage()
        }
        ctx.router.register(
            "/app/standups/new",
        ) { pageCtx -> 
            _co_maytes_standupbot_dashboard_pages_app_standups_NewTeamPage()
        }
        ctx.router.register(
            "/app/standups/{id}",
        ) { pageCtx -> 
            _co_maytes_standupbot_dashboard_pages_app_standups_TeamDetailPage()
        }
        ctx.router.register(
            "/app/summary",
        ) { pageCtx -> 
            _co_maytes_standupbot_dashboard_pages_app_summary_SummaryPage()
        }
        ctx.router.register(
            "/app/templates",
        ) { pageCtx -> 
            _co_maytes_standupbot_dashboard_pages_app_templates_TemplatesIndexPage()
        }
        ctx.router.register(
            "/app/templates/new",
        ) { pageCtx -> 
            _co_maytes_standupbot_dashboard_pages_app_templates_TemplatesNewPage()
        }
        ctx.router.register(
            "/app/templates/{templateId}",
        ) { pageCtx -> 
            _co_maytes_standupbot_dashboard_pages_app_templates_TemplatesDynamicPage()
        }
        ctx.router.register(
            "/bootstrap",
        ) { pageCtx -> 
            _co_maytes_standupbot_dashboard_pages_BootstrapPage()
        }
        ctx.router.register(
            "/changelog",
        ) { pageCtx -> 
            _co_maytes_standupbot_dashboard_pages_ChangelogPage()
        }
        ctx.router.register(
            "/contact",
        ) { pageCtx -> 
            _co_maytes_standupbot_dashboard_pages_ContactPage()
        }
        ctx.router.register(
            "/docs",
        ) { pageCtx -> 
            _co_maytes_standupbot_dashboard_pages_DocsPage()
        }
        ctx.router.register(
            "/docs/anthropic-key",
        ) { pageCtx -> 
            _co_maytes_standupbot_dashboard_pages_AnthropicKeyPage()
        }
        ctx.router.register(
            "/ds",
        ) { pageCtx -> 
            _co_maytes_standupbot_dashboard_pages_ds_DesignSystemPage()
        }
        ctx.router.register(
            "/invite/accept",
        ) { pageCtx -> 
            _co_maytes_standupbot_dashboard_pages_InviteAcceptPage()
        }
        ctx.router.register(
            "/legal/privacy",
        ) { pageCtx -> 
            _co_maytes_standupbot_dashboard_pages_legal_PrivacyPage()
        }
        ctx.router.register(
            "/legal/terms",
        ) { pageCtx -> 
            _co_maytes_standupbot_dashboard_pages_legal_TermsPage()
        }
        ctx.router.register(
            "/oauth/linear-callback",
        ) { pageCtx -> 
            _co_maytes_standupbot_dashboard_pages_oauth_LinearCallbackPage()
        }
        ctx.router.register(
            "/oauth/slack-callback",
        ) { pageCtx -> 
            _co_maytes_standupbot_dashboard_pages_oauth_SlackCallbackPage()
        }
        ctx.router.register(
            "/pricing",
        ) { pageCtx -> 
            _co_maytes_standupbot_dashboard_pages_PricingPage()
        }
        ctx.router.register(
            "/signin",
        ) { pageCtx -> 
            _co_maytes_standupbot_dashboard_pages_SignInPage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("member-row", co.maytes.standupbot.dashboard.features.settings.MemberRowStyle)
        ctx.theme.registerStyle("identity-link", co.maytes.standupbot.dashboard.features.settings.IdentityLinkStyle)
        ctx.theme.registerStyle("roster-row", co.maytes.standupbot.dashboard.features.roster.RosterRowStyle)
        ctx.theme.registerStyle("roster-text-action", co.maytes.standupbot.dashboard.features.roster.RosterTextActionStyle)
        ctx.theme.registerStyle("active-nav-row", co.maytes.standupbot.dashboard.components.layout.ActiveNavRowStyle)
        ctx.theme.registerStyle("inactive-nav-row", co.maytes.standupbot.dashboard.components.layout.InactiveNavRowStyle)
        ctx.theme.registerStyle("skeleton-pulse", co.maytes.standupbot.dashboard.components.feedback.SkeletonPulseStyle)
        ctx.theme.registerStyle("card", co.maytes.standupbot.dashboard.components.widgets.CardStyle)
        ctx.theme.registerStyle("interactive-card", co.maytes.standupbot.dashboard.components.widgets.InteractiveCardStyle)
        ctx.theme.registerStyle("spinner", co.maytes.standupbot.dashboard.components.widgets.SpinnerStyle)
        ctx.theme.registerStyle("segmented-track", co.maytes.standupbot.dashboard.components.widgets.SegmentedTrackStyle)
        ctx.theme.registerStyle("segment", co.maytes.standupbot.dashboard.components.widgets.SegmentStyle)
        ctx.theme.registerStyle("text-input", co.maytes.standupbot.dashboard.components.widgets.TextInputStyle)
        ctx.theme.registerStyle("tooltip", co.maytes.standupbot.dashboard.components.widgets.TooltipStyle)
        co.maytes.standupbot.dashboard.init.initSiteTheme(ctx)
        co.maytes.standupbot.dashboard.features.settings.initMembersTableStyles(ctx)
        co.maytes.standupbot.dashboard.features.settings.initLogTableStyles(ctx)
        co.maytes.standupbot.dashboard.features.settings.initBillingStripStyles(ctx)
        co.maytes.standupbot.dashboard.features.releases.initReleaseFeedStyles(ctx)
        co.maytes.standupbot.dashboard.styles.initMarketingStyles(ctx)
        co.maytes.standupbot.dashboard.styles.initSiteKeyframes(ctx)
        co.maytes.standupbot.dashboard.styles.initSiteCssRules(ctx)
        co.maytes.standupbot.dashboard.styles.initHomeStyles(ctx)
        co.maytes.standupbot.dashboard.styles.initDesignSystemStyles(ctx)
        co.maytes.standupbot.dashboard.styles.initSettingsStyles(ctx)
        co.maytes.standupbot.dashboard.styles.initHealthStripStyles(ctx)
        co.maytes.standupbot.dashboard.styles.initOnboardingStyles(ctx)
        co.maytes.standupbot.dashboard.styles.initControlKeyframes(ctx)
        co.maytes.standupbot.dashboard.styles.initControlStyles(ctx)
        co.maytes.standupbot.dashboard.components.widgets.initSpinnerKeyframes(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        co.maytes.standupbot.dashboard.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
